export default __webpack_public_path__ + "static/media/header.88355242.png";